@if (spansMultipleColumns()) {
    {{ name() }}
} @else {
    {{ name() | wrapHeaderText }}
}
<ng-content />
